<template>
  <!-- Terms & Conditions Checkbox -->
    <div class="form-group">
        <div class=" custom-checkbox">
            <input
                    id="terms-checkbox"
                    type="checkbox"
                    v-model="terms"
                    @blur="onBlur"
                    @focus="onFocus"
                    @change="emit('change', terms)" />
            <span v-html="props.label" />
        </div>

        <span v-if="props.valid.$errors.length" class="error-message">
            Your must agree to Terms and Conditions and Privacy Policy.
        </span>
    </div>
</template>

<script setup>
import {ref} from 'vue'
import { onBlur, onFocus } from './fields.js'

const props = defineProps({
    label: String,
    placeholder: String,
    valid: Object
})

const emit = defineEmits(['change'])
const terms = ref()
</script>

<style scoped lang="scss">
  .custom-checkbox {
    display: flex;

    input {
      width: 32px;
      height: 32px;
    }

    span {
      color: #333333;
      padding-left: 10px;
    }
  }
</style>